import React from 'react';

// For the implementation of this, please refer https://mui.com/material-ui/react-text-field/

import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface NumericFormattedInputProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const NumericFormattedInput = React.forwardRef<NumericFormatProps, NumericFormattedInputProps>(
    function NumericFormattedInput(props, ref) {
        const { onChange, ...other } = props;

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                valueIsNumericString
            />
        );
    }
);

export default NumericFormattedInput;
